const isBrowserImageSrc = (value) =>
  typeof value === 'string' &&
  (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:'));

export const resolveImageSrc = (item) => {
  if (!item) return null;
  if (isBrowserImageSrc(item.imageUrl)) return item.imageUrl;
  if (isBrowserImageSrc(item.frontImageUrl)) return item.frontImageUrl;
  if (isBrowserImageSrc(item.image)) return item.image;
  if (typeof item.image === 'string' && item.image.length > 0) {
    return `data:image/jpeg;base64,${item.image}`;
  }
  return item.imageUrl || null;
};
